import { render, staticRenderFns } from "./MaskDesign.vue?vue&type=template&id=052cd096&scoped=true&"
import script from "./MaskDesign.vue?vue&type=script&lang=js&"
export * from "./MaskDesign.vue?vue&type=script&lang=js&"
import style0 from "./MaskDesign.vue?vue&type=style&index=0&id=052cd096&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052cd096",
  null
  
)

export default component.exports